export class Utils {

    public static formatDate(date): string {
        const localDate = new Date(date);
        let month = '' + (localDate.getMonth() + 1);
        let day = '' + localDate.getDate();
        const year = localDate.getFullYear();

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }
        return [day, month, year].join('/');
    }
}
